/**
 * wagbappro.id WA GB Versi Lama 页印尼语内容（文案 1:1 还原需求文档）
 */

export const intro = {
  paragraph: {
    textBefore: 'WA GB Versi Lama adalah pilihan bagi pengguna yang ingin menggunakan versi ',
    linkText: 'GB WhatsApp',
    linkTo: '/',
    textAfter:
      ' sebelumnya yang lebih ringan, stabil, atau kompatibel dengan perangkat Android tertentu.',
  },
  latestVersion: 'v21.30',
  cta: 'Unduh WA GB Versi Lama Sekarang',
  ctaLink: '/unduh-gb-wa/',
};

export const sections = {
  whyOld: {
    id: 'kenapa-memilih-versi-lama',
    title: 'Kenapa Memilih Versi Lama?',
    intro: 'Beberapa pengguna memilih WA GB versi lama karena:',
    items: [
      'Lebih ringan di perangkat dengan spesifikasi rendah',
      'Tampilan lebih sederhana dan stabil',
      'Beberapa fitur lama masih lebih nyaman digunakan',
      'Kompatibilitas lebih luas untuk Android versi lama',
      'Tidak selalu membutuhkan update terbaru',
    ],
  },
  versionList: {
    id: 'daftar-wa-gb-versi-lama',
    title: 'Daftar WA GB Versi Lama',
    intro: 'Berikut beberapa versi GB WhatsApp yang bisa kamu pilih:',
    /** UI 效果卡片数据（纯 CSS 渲染，非 content 图片） */
    cards: [
      {
        version: 'v21.25',
        title: '📦 v21.25',
        desc: 'Versi ringan dan stabil, cocok untuk penggunaan harian tanpa lag.',
        cta: 'Unduh v21.25',
        ctaLink: '/unduh-gb-wa/',
      },
      {
        version: 'v18.80',
        title: '📦 v18.80',
        desc: 'Versi dengan kompatibilitas luas untuk Android 5.0+ dan perangkat lama.',
        cta: 'Unduh v18.80',
        ctaLink: '/unduh-gb-wa/',
      },
      {
        version: 'v18.30',
        title: '📦 v18.30',
        desc: 'Versi lama dengan fitur dasar yang stabil dan ringan digunakan.',
        cta: 'Unduh v18.30',
        ctaLink: '/unduh-gb-wa/',
      },
      {
        version: 'v17.55',
        title: '📦 v17.55',
        desc: 'Versi ringan untuk perangkat low-end dengan performa sederhana.',
        cta: 'Unduh v17.55',
        ctaLink: '/unduh-gb-wa/',
      },
      {
        version: 'v17.20',
        title: '📦 v17.20',
        desc: 'Versi klasik GB WhatsApp dengan fitur dasar dan stabilitas cukup baik.',
        cta: 'Unduh v17.20',
        ctaLink: '/unduh-gb-wa/',
      },
    ],
  },
  advantages: {
    id: 'kelebihan-wa-gb-versi-lama',
    title: 'Kelebihan WA GB Versi Lama',
    items: [
      'Lebih stabil di beberapa perangkat lama',
      'Tidak terlalu berat seperti versi terbaru',
      'Cocok untuk HP Android spesifikasi rendah',
      'Penggunaan lebih sederhana dan cepat',
      'Minim perubahan fitur yang membingungkan',
    ],
  },
  notice: {
    id: 'catatan-penting',
    title: 'Catatan Penting',
    text: 'WA GB Versi Lama adalah aplikasi modifikasi, sehingga tidak tersedia di Google Play Store. Pastikan kamu mengunduh dari sumber yang aman dan selalu melakukan backup sebelum instalasi untuk menghindari kehilangan data.',
  },
  conclusion: {
    id: 'kesimpulan',
    title: 'Kesimpulan',
    text: 'WA GB Versi Lama cocok untuk pengguna yang menginginkan versi WhatsApp mod yang lebih ringan, stabil, dan sederhana. Pilih versi yang sesuai dengan kebutuhan perangkat kamu untuk mendapatkan pengalaman terbaik.',
  },
};
